import Generic from './generic';
import NoUser from './noUser';

const NotFound = {
  Generic,
  NoUser,
};

export default NotFound;
